module.exports = "<ion-view\r\n  class=\"wizard\"\r\n  title=\"Login\"\r\n  cache-view=\"false\"\r\n>\r\n  <react-component\r\n    class=\"wizard\"\r\n    name=\"InvitationLogin\"\r\n    props=\"inviteLogin.props\"\r\n    watch-depth=\"reference\">\r\n  </react-component>\r\n</ion-view>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/auth/controllers/invitation-login.html
// module id = 2276
// module chunks = 0